import {PlateElement, usePlaceholderState} from "@udecode/plate/react";
import styles from "../styles/SlateEditor.module.scss";

export function Paragraph(props: any) {
    const { enabled } = usePlaceholderState(props);

    return <PlateElement {...props}
                         className={enabled ? styles.paragraphPlaceholder : ""}
    >
        {props.children}
    </PlateElement>
}